import * as React from "react";

export interface UserThemeContextContent {
  userTheme: string;
  setUserTheme: React.Dispatch<React.SetStateAction<string>>;
}

export const UserThemeContext = React.createContext<UserThemeContextContent | undefined>(undefined);
